export const countryStateCityData = {
  "United Kingdom": {
    "London": ["London", "Westminster", "Croydon", "Wembley", "Stratford", "Hounslow"],
    "Birmingham": ["Birmingham", "Solihull", "Wolverhampton", "West Bromwich", "Dudley", "Walsall"],
    "Manchester": ["Manchester", "Salford", "Bolton", "Stockport", "Oldham", "Rochdale"],
    "Leeds": ["Leeds", "Bradford", "Wakefield", "Huddersfield", "Halifax", "Dewsbury"],
    "Liverpool": ["Liverpool", "Birkenhead", "St Helens", "Bootle", "Southport", "Wallasey"]
  },
  "Croatia": {
    "City of Zagreb": ["Zagreb", "Sesvete", "Novi Zagreb"],
    "Zagreb County": ["Velika Gorica", "Samobor", "Zaprešić", "Dugo Selo"],
    "Split-Dalmatia County": ["Split", "Sinj", "Solin", "Kaštela", "Trogir", "Makarska"],
    "Istria County": ["Pula", "Poreč", "Rovinj", "Umag", "Labin", "Buzet"],
    "Primorje-Gorski Kotar County": ["Rijeka", "Opatija", "Crikvenica", "Kraljevica", "Delnice"],
    "Osijek-Baranja County": ["Osijek", "Belišće", "Donji Miholjac", "Beli Manastir"],
    "Varaždin County": ["Varaždin", "Ivanec", "Ludbreg", "Lepoglava"],
    "Međimurje County": ["Čakovec", "Prelog", "Mursko Središće"],
    "Šibenik-Knin County": ["Šibenik", "Knin", "Drniš", "Vodice"],
    "Zadar County": ["Zadar", "Biograd na Moru", "Benkovac", "Nin"],
    "Bjelovar-Bilogora County": ["Bjelovar", "Čazma", "Garešnica", "Grubišno Polje"],
    "Brod-Posavina County": ["Slavonski Brod", "Nova Gradiška", "Vrpolje"],
    "Dubrovnik-Neretva County": ["Dubrovnik", "Metković", "Ploče", "Korčula", "Opuzen"],
    "Karlovac County": ["Karlovac", "Ogulin", "Duga Resa", "Slunj"],
    "Koprivnica-Križevci County": ["Koprivnica", "Križevci", "Đurđevac"],
    "Krapina-Zagorje County": ["Krapina", "Zabok", "Pregrada", "Donja Stubica"],
    "Lika-Senj County": ["Gospić", "Otočac", "Senj", "Novalja"],
    "Požega-Slavonia County": ["Požega", "Pleternica", "Kutjevo"],
    "Sisak-Moslavina County": ["Sisak", "Petrinja", "Kutina", "Glina"],
    "Virovitica-Podravina County": ["Virovitica", "Orahovica", "Slatina"],
    "Vukovar-Srijem County": ["Vukovar", "Vinkovci", "Županja", "Ilok"]
  },
  "Turkey": {
    "Adana": ["Adana", "Ceyhan", "Kozan", "Feke", "Saimbeyli"],
    "Adıyaman": ["Adıyaman", "Kahta", "Besni", "Gölbaşı", "Çelikhan"],
    "Afyonkarahisar": ["Afyonkarahisar", "Sandıklı", "Dinar", "Bolvadin", "Sinanpaşa"],
    "Ağrı": ["Ağrı", "Patnos", "Doğubayazıt", "Diyadin", "Tutak"],
    "Amasya": ["Amasya", "Merzifon", "Suluova", "Taşova", "Göynücek"],
    "Ankara": ["Ankara", "Polatlı", "Çubuk", "Beypazarı", "Kızılcahamam"],
    "Antalya": ["Antalya", "Alanya", "Manavgat", "Serik", "Kaş"],
    "Artvin": ["Artvin", "Hopa", "Arhavi", "Yusufeli", "Borçka"],
    "Aydın": ["Aydın", "Nazilli", "Söke", "Kuşadası", "Didim"],
    "Balıkesir": ["Balıkesir", "Bandırma", "Edremit", "Gönen", "Burhaniye"],
    "Bilecik": ["Bilecik", "Bozüyük", "Söğüt", "Osmaneli", "Pazaryeri"],
    "Bitlis": ["Bitlis", "Tatvan", "Ahlat", "Hizan", "Mutki"],
    "Bolu": ["Bolu", "Gerede", "Mudurnu", "Dörtdivan", "Yeniçağa"],
    "Burdur": ["Burdur", "Bucak", "Gölhisar", "Tefenni", "Yeşilova"],
    "Bursa": ["Bursa", "İnegöl", "Gemlik", "Mustafakemalpaşa", "Orhangazi"],
    "Çanakkale": ["Çanakkale", "Bigadiç", "Çan", "Biga", "Ezine"],
    "Çankırı": ["Çankırı", "Çerkeş", "Ilgaz", "Orta", "Şabanözü"],
    "Çorum": ["Çorum", "İskilip", "Sungurlu", "Osmancık", "Alaca"],
    "Denizli": ["Denizli", "Pamukkale", "Çivril", "Tavas", "Buldan"],
    "Diyarbakır": ["Diyarbakır", "Bismil", "Silvan", "Ergani", "Çınar"],
    "Edirne": ["Edirne", "Keşan", "Uzunköprü", "İpsala", "Havsa"],
    "Elazığ": ["Elazığ", "Kovancılar", "Keban", "Maden", "Sivrice"],
    "Erzincan": ["Erzincan", "Refahiye", "Çayırlı", "İliç", "Kemah"],
    "Erzurum": ["Erzurum", "Pasinler", "Horasan", "Oltu", "İspir"],
    "Eskişehir": ["Eskişehir", "Sivrihisar", "Çifteler", "Alpu", "Mihalıççık"],
    "Gaziantep": ["Gaziantep", "Şahinbey", "Şehitkamil", "Nizip", "İslahiye"],
    "Giresun": ["Giresun", "Bulancak", "Espiye", "Tirebolu", "Görele"],
    "Gümüşhane": ["Gümüşhane", "Kelkit", "Şiran", "Köse", "Torul"],
    "Hakkari": ["Hakkari", "Yüksekova", "Çukurca", "Şemdinli", "Derecik"],
    "Hatay": ["Antakya", "İskenderun", "Dörtyol", "Reyhanlı", "Samandağ"],
    "Isparta": ["Isparta", "Yalvaç", "Eğirdir", "Şarkikaraağaç", "Gelendost"],
    "Mersin": ["Mersin", "Tarsus", "Silifke", "Erdemli", "Anamur"],
    "Istanbul": ["Istanbul", "Kadıköy", "Üsküdar", "Beşiktaş", "Fatih", "Beyoğlu"],
    "Izmir": ["Izmir", "Bornova", "Karşıyaka", "Buca", "Konak", "Çeşme"],
    "Kars": ["Kars", "Sarıkamış", "Kağızman", "Digor", "Selim"],
    "Kastamonu": ["Kastamonu", "Taşköprü", "İnebolu", "Tosya", "Cide"],
    "Kayseri": ["Kayseri", "Develi", "Yahyalı", "Bünyan", "Pınarbaşı"],
    "Kırklareli": ["Kırklareli", "Lüleburgaz", "Babaeski", "Vize", "Pınarhisar"],
    "Kırşehir": ["Kırşehir", "Kaman", "Mucur", "Çiçekdağı", "Akpınar"],
    "Kocaeli": ["İzmit", "Gebze", "Darıca", "Körfez", "Gölcük"],
    "Konya": ["Konya", "Ereğli", "Akşehir", "Beyşehir", "Çumra"],
    "Kütahya": ["Kütahya", "Tavşanlı", "Simav", "Emet", "Gediz"],
    "Malatya": ["Malatya", "Battalgazi", "Doğanşehir", "Yeşilyurt", "Akçadağ"],
    "Manisa": ["Manisa", "Akhisar", "Salihli", "Turgutlu", "Soma"],
    "Kahramanmaraş": ["Kahramanmaraş", "Elbistan", "Afşin", "Pazarcık", "Göksun"],
    "Mardin": ["Mardin", "Kızıltepe", "Nusaybin", "Derik", "Mazıdağı"],
    "Muğla": ["Muğla", "Bodrum", "Fethiye", "Marmaris", "Milas"],
    "Muş": ["Muş", "Bulanık", "Malazgirt", "Varto", "Korkut"],
    "Nevşehir": ["Nevşehir", "Ürgüp", "Avanos", "Gülşehir", "Hacıbektaş"],
    "Niğde": ["Niğde", "Bor", "Çiftlik", "Ulukışla", "Altunhisar"],
    "Ordu": ["Ordu", "Ünye", "Fatsa", "Perşembe", "Kumru"],
    "Rize": ["Rize", "Çayeli", "Pazar", "Ardeşen", "Fındıklı"],
    "Sakarya": ["Adapazarı", "Sapanca", "Akyazı", "Hendek", "Karapürçek"],
    "Samsun": ["Samsun", "Bafra", "Çarşamba", "Terme", "Vezirköprü"],
    "Siirt": ["Siirt", "Kurtalan", "Pervari", "Şirvan", "Baykan"],
    "Sinop": ["Sinop", "Boyabat", "Ayancık", "Gerze", "Durağan"],
    "Sivas": ["Sivas", "Şarkışla", "Yıldızeli", "Zara", "Suşehri"],
    "Tekirdağ": ["Tekirdağ", "Çorlu", "Çerkezköy", "Malkara", "Saray"],
    "Tokat": ["Tokat", "Turhal", "Zile", "Erbaa", "Niksar"],
    "Trabzon": ["Trabzon", "Akçaabat", "Araklı", "Vakfıkebir", "Of"],
    "Tunceli": ["Tunceli", "Pertek", "Çemişgezek", "Hozat", "Mazgirt"],
    "Şanlıurfa": ["Şanlıurfa", "Siverek", "Viranşehir", "Ceylanpınar", "Birecik"],
    "Uşak": ["Uşak", "Banaz", "Eşme", "Sivaslı", "Ulubey"],
    "Van": ["Van", "Erciş", "Başkale", "Çatak", "Gevaş"],
    "Yozgat": ["Yozgat", "Sorgun", "Akdağmadeni", "Yerköy", "Çekerek"],
    "Zonguldak": ["Zonguldak", "Kozlu", "Çaycuma", "Devrek", "Ereğli"]
  },
  "UAE": {
    "Abu Dhabi": ["Abu Dhabi", "Al Ain", "Madinat Zayed", "Ruwais", "Liwa", "Ghayathi"],
    "Dubai": ["Dubai", "Jebel Ali", "Hatta"],
    "Sharjah": ["Sharjah", "Khor Fakkan", "Kalba", "Dibba Al-Hisn", "Al Dhaid"],
    "Ajman": ["Ajman", "Masfout", "Manama"],
    "Ras Al Khaimah": ["Ras Al Khaimah", "Al Jazirah Al Hamra", "Khatt", "Rams"],
    "Fujairah": ["Fujairah", "Dibba Al-Fujairah"],
    "Umm Al Quwain": ["Umm Al Quwain", "Falaj Al Mualla"]
  },
  "Qatar": {
    "Doha": ["Doha", "West Bay", "Al Dafna", "Al Sadd", "Bin Mahmoud", "Old Doha"],
    "Al Rayyan": ["Al Rayyan", "Al Wakrah Camp", "Education City", "Al Gharrafa", "Al Wajba"],
    "Al Wakrah": ["Al Wakrah", "Al Wukair", "Mesaieed"],
    "Umm Salal": ["Umm Salal Mohammed", "Umm Salal Ali"],
    "Al Daayen": ["Lusail", "Al Daayen", "Umm Qarn"],
    "Al Khor": ["Al Khor", "Al Thakhira"],
    "Al Shamal": ["Madinat ash Shamal", "Ar Ru'ays"]
  },
  "Saudi Arabia": {
    "Riyadh": ["Riyadh", "Diriyah", "Al Kharj", "Al Majma'ah", "Dawadmi", "Shaqra"],
    "Makkah": ["Makkah", "Jeddah", "Taif", "Rabigh", "Al Lith"],
    "Madinah": ["Madinah", "Yanbu", "Al Ula", "Badr"],
    "Eastern Province – Dammam": ["Dammam", "Khobar", "Dhahran", "Jubail", "Qatif", "Ras Tanura", "Al Ahsa (Hofuf)"],
    "Asir": ["Abha", "Khamis Mushait", "Ahad Rifaidah", "Mahayel Aseer"],
    "Jazan": ["Jazan", "Sabya", "Abu Arish", "Al Ardah"],
    "Najran": ["Najran", "Sharurah", "Hubuna"],
    "Al Qassim": ["Buraidah", "Unaizah", "Al Rass", "Al Bukayriyah"],
    "Tabuk": ["Tabuk", "Duba", "Umluj", "Tayma"],
    "Hail": ["Hail", "Baqaa", "Ghazalah"],
    "Al Jawf": ["Sakaka", "Qurayyat", "Dumat Al Jandal"],
    "Northern Borders": ["Arar", "Rafha", "Turaif"],
    "Al Baha": ["Al Baha", "Baljurashi", "Al Makhwah"]
  },
  "Oman": {
    "Muscat": ["Muscat", "Muttrah", "Ruwi", "Seeb", "Bawshar", "Al Amerat"],
    "Dhofar": ["Salalah", "Taqah", "Mirbat", "Thumrait", "Rakhyut"],
    "Al Batinah North": ["Sohar", "Shinas", "Liwa", "Saham", "Al Khaburah"],
    "Al Batinah South": ["Rustaq", "Awabi", "Nakhal", "Wadi Al Maawil"],
    "Al Dakhiliyah": ["Nizwa", "Bahla", "Adam", "Manah", "Izki", "Samail"],
    "Al Sharqiyah North": ["Ibra", "Bidiyah", "Al Mudhaibi", "Qabil"],
    "Al Sharqiyah South": ["Sur", "Jalan Bani Bu Ali", "Jalan Bani Bu Hassan", "Masirah"],
    "Al Dhahirah": ["Ibri", "Yanqul", "Dhank"],
    "Al Buraimi": ["Al Buraimi", "Mahdah", "Al Sunaynah"],
    "Al Wusta": ["Haima", "Duqm", "Mahout"],
    "Musandam": ["Khasab", "Bukha", "Dibba Al-Bayah"]
  },
  "Kuwait": {
    "Al Asimah (Capital)": ["Kuwait City", "Sharq", "Dasman", "Qibla", "Mirqab", "Dasma"],
    "Hawalli": ["Hawalli", "Salmiya", "Jabriya", "Bayan", "Mishref", "Rumaithiya", "Salwa"],
    "Farwaniya": ["Farwaniya", "Khaitan", "Abbassiya", "Riggae", "Jleeb Al-Shuyoukh", "Omariya"],
    "Ahmadi": ["Ahmadi", "Fahaheel", "Mangaf", "Mahboula", "Riqqa", "Hadiya", "Sabahiya"],
    "Jahra": ["Jahra", "Qasr", "Sulaibiya", "Taima", "Saad Al Abdullah"],
    "Mubarak Al-Kabeer": ["Mubarak Al-Kabeer", "Sabah Al-Salem", "Al-Adan", "Qurain", "Abu Al-Hasaniya", "Abu Futaira"]
  },
  "Bahrain": {
    "Capital Governorate": ["Manama", "Seef", "Juffair", "Diplomatic Area", "Sanabis", "Karbabad"],
    "Muharraq Governorate": ["Muharraq", "Hidd", "Arad", "Galali", "Diyar Al Muharraq"],
    "Northern Governorate": ["A'ali", "Barbar", "Budaiya", "Diraz", "Hamad Town", "Saar"],
    "Southern Governorate": ["Riffa", "Isa Town", "Sakhir", "Zallaq", "Awali", "East Riffa", "West Riffa"]
  },
  "Singapore": {
    "Central Region": ["Singapore (CBD)", "Orchard", "Marina Bay", "Bugis", "Chinatown", "Little India", "Tiong Bahru"],
    "East Region": ["Tampines", "Bedok", "Pasir Ris", "Changi", "Simei"],
    "West Region": ["Jurong East", "Jurong West", "Clementi", "Bukit Batok", "Bukit Panjang", "Tuas"],
    "North Region": ["Woodlands", "Yishun", "Sembawang", "Admiralty"],
    "North-East Region": ["Hougang", "Sengkang", "Punggol", "Serangoon"]
  },
  "Malaysia": {
    "Johor": ["Johor Bahru", "Iskandar Puteri", "Batu Pahat", "Kluang", "Muar", "Pontian"],
    "Kedah": ["Alor Setar", "Sungai Petani", "Kulim", "Langkawi"],
    "Kelantan": ["Kota Bharu", "Pasir Mas", "Tumpat", "Tanah Merah"],
    "Melaka": ["Melaka City", "Ayer Keroh", "Alor Gajah", "Jasin"],
    "Negeri Sembilan": ["Seremban", "Port Dickson", "Nilai", "Tampin"],
    "Pahang": ["Kuantan", "Temerloh", "Bentong", "Raub", "Cameron Highlands"],
    "Penang (Pulau Pinang)": ["George Town", "Butterworth", "Bukit Mertajam", "Bayan Lepas"],
    "Perak": ["Ipoh", "Taiping", "Teluk Intan", "Batu Gajah", "Lumut"],
    "Perlis": ["Kangar", "Kuala Perlis"],
    "Sabah": ["Kota Kinabalu", "Sandakan", "Tawau", "Lahad Datu"],
    "Sarawak": ["Kuching", "Miri", "Sibu", "Bintulu"],
    "Selangor": ["Shah Alam", "Petaling Jaya", "Subang Jaya", "Klang", "Cyberjaya"],
    "Terengganu": ["Kuala Terengganu", "Dungun", "Kemaman", "Marang"],
    "Federal Territory of Kuala Lumpur": ["Kuala Lumpur"],
    "Federal Territory of Putrajaya": ["Putrajaya"],
    "Federal Territory of Labuan": ["Labuan"]
  },
  "Hong Kong": {
    "Hong Kong Island": ["Central", "Admiralty", "Wan Chai", "Causeway Bay", "North Point", "Quarry Bay", "Aberdeen"],
    "Kowloon": ["Tsim Sha Tsui", "Mong Kok", "Yau Ma Tei", "Jordan", "Sham Shui Po", "Kowloon City", "Hung Hom"],
    "New Territories": ["Sha Tin", "Tai Po", "Tsuen Wan", "Tuen Mun", "Yuen Long", "Fanling", "Sheung Shui"],
    "Outlying Islands": ["Lantau Island", "Tung Chung", "Cheung Chau", "Lamma Island", "Peng Chau"]
  },
  "Taiwan": {
    "Taipei City": ["Taipei", "Zhongshan", "Wanhua", "Da'an", "Xinyi"],
    "New Taipei City": ["Banqiao", "Xinzhuang", "Tamsui", "Sanchong", "Linkou"],
    "Taoyuan City": ["Taoyuan", "Zhongli", "Bade", "Luzhu"],
    "Taichung City": ["Taichung", "Fengyuan", "Dali", "Beitun"],
    "Tainan City": ["Tainan", "Yongkang", "Rende"],
    "Kaohsiung City": ["Kaohsiung", "Zuoying", "Lingya", "Xiaogang"]
  },
  "South Korea": {
    "Seoul": ["Seoul", "Gangnam", "Jongno", "Mapo", "Songpa", "Yeongdeungpo"],
    "Busan": ["Busan", "Haeundae", "Suyeong", "Dongnae", "Sasang"],
    "Incheon": ["Incheon", "Bupyeong", "Namdong", "Yeonsu", "Songdo"],
    "Daegu": ["Daegu", "Suseong", "Dalseo", "Dong"],
    "Daejeon": ["Daejeon", "Yuseong", "Seo", "Dong"],
    "Gwangju": ["Gwangju", "Buk", "Seo", "Gwangsan"],
    "Ulsan": ["Ulsan", "Nam", "Dong", "Buk"],
    "Gyeonggi-do": ["Suwon", "Seongnam", "Goyang", "Yongin", "Bucheon", "Ansan", "Anyang"],
    "Gangwon-do": ["Chuncheon", "Wonju", "Gangneung", "Donghae"],
    "Chungcheongbuk-do": ["Cheongju", "Chungju", "Jecheon"],
    "Chungcheongnam-do": ["Cheonan", "Asan", "Seosan", "Dangjin"],
    "Jeollabuk-do": ["Jeonju", "Iksan", "Gunsan"],
    "Jeollanam-do": ["Mokpo", "Yeosu", "Suncheon", "Gwangyang"],
    "Gyeongsangbuk-do": ["Pohang", "Gumi", "Andong", "Gyeongju"],
    "Gyeongsangnam-do": ["Changwon", "Gimhae", "Jinju", "Yangsan"],
    "Jeju Special Self-Governing Province": ["Jeju City", "Seogwipo"]
  },
  "Japan": {
    "Tokyo": ["Tokyo", "Shinjuku", "Shibuya", "Minato", "Chiyoda", "Taito", "Ikebukuro"],
    "Kanagawa": ["Yokohama", "Kawasaki", "Yokosuka", "Kamakura"],
    "Osaka": ["Osaka", "Sakai", "Toyonaka", "Higashiosaka"],
    "Aichi": ["Nagoya", "Toyota", "Okazaki", "Ichinomiya"],
    "Saitama": ["Saitama", "Kawaguchi", "Kawagoe", "Tokorozawa"],
    "Chiba": ["Chiba", "Funabashi", "Matsudo", "Ichikawa"],
    "Hyogo": ["Kobe", "Himeji", "Nishinomiya", "Amagasaki"],
    "Hokkaido": ["Sapporo", "Hakodate", "Asahikawa"],
    "Fukuoka": ["Fukuoka", "Kitakyushu", "Kurume"],
    "Hiroshima": ["Hiroshima", "Fukuyama", "Kure"],
    "Kyoto": ["Kyoto", "Uji", "Kameoka"],
    "Okinawa": ["Naha", "Okinawa City", "Uruma"]
  },
  "Germany": {
    "Bavaria (Bayern)": ["Munich", "Nuremberg", "Augsburg", "Regensburg", "Würzburg"],
    "North Rhine-Westphalia": ["Cologne", "Düsseldorf", "Dortmund", "Essen", "Duisburg", "Bochum"],
    "Baden-Württemberg": ["Stuttgart", "Mannheim", "Karlsruhe", "Freiburg", "Heidelberg"],
    "Hesse (Hessen)": ["Frankfurt am Main", "Wiesbaden", "Darmstadt", "Kassel", "Offenbach"],
    "Lower Saxony (Niedersachsen)": ["Hanover", "Wolfsburg", "Braunschweig", "Oldenburg", "Osnabrück"],
    "Berlin (City State)": ["Berlin", "Mitte", "Charlottenburg", "Neukölln", "Kreuzberg"],
    "Hamburg (City State)": ["Hamburg", "Altona", "Wandsbek", "Eimsbüttel"],
    "Saxony (Sachsen)": ["Dresden", "Leipzig", "Chemnitz"],
    "Rhineland-Palatinate (Rheinland-Pfalz)": ["Mainz", "Ludwigshafen", "Koblenz", "Trier"],
    "Schleswig-Holstein": ["Kiel", "Lübeck", "Flensburg", "Neumünster"],
    "Brandenburg": ["Potsdam", "Cottbus", "Brandenburg an der Havel"],
    "Saarland": ["Saarbrücken", "Neunkirchen", "Homburg"],
    "Bremen (City State)": ["Bremen", "Bremerhaven"],
    "Mecklenburg-Vorpommern": ["Rostock", "Schwerin", "Wismar"],
    "Thuringia (Thüringen)": ["Erfurt", "Jena", "Weimar"],
    "Saxony-Anhalt (Sachsen-Anhalt)": ["Magdeburg", "Halle (Saale)", "Dessau-Roßlau"]
  },
  "Netherlands": {
    "Noord-Holland": ["Amsterdam", "Haarlem"],
    "Zuid-Holland": ["Rotterdam", "The Hague", "Leiden"],
    "Utrecht": ["Utrecht"],
    "Noord-Brabant": ["Eindhoven", "Tilburg"],
    "Gelderland": ["Arnhem", "Nijmegen"],
    "Overijssel": ["Enschede", "Zwolle"],
    "Limburg": ["Maastricht"],
    "Groningen": ["Groningen"],
    "Friesland": ["Leeuwarden"],
    "Drenthe": ["Assen"],
    "Flevoland": ["Almere", "Lelystad"],
    "Zeeland": ["Middelburg"]
  },
  "Poland": {
    "Masovian Voivodeship": ["Warsaw", "Radom", "Płock", "Siedlce", "Pruszków", "Legionowo", "Ostrołęka"],
    "Lesser Poland Voivodeship": ["Krakow", "Tarnów", "Nowy Sącz", "Oświęcim", "Chrzanów", "Olkusz", "Zakopane"],
    "Silesian Voivodeship": ["Katowice", "Częstochowa", "Sosnowiec", "Gliwice", "Zabrze", "Bytom", "Ruda Śląska", "Rybnik"],
    "Greater Poland Voivodeship": ["Poznań", "Kalisz", "Konin", "Piła", "Ostrów Wielkopolski", "Gniezno", "Leszno"],
    "Lower Silesian Voivodeship": ["Wrocław", "Wałbrzych", "Legnica", "Jelenia Góra", "Lubin", "Głogów", "Świdnica"],
    "Łódź Voivodeship": ["Łódź", "Piotrków Trybunalski", "Pabianice", "Tomaszów Mazowiecki", "Zgierz", "Skierniewice"],
    "Pomeranian Voivodeship": ["Gdańsk", "Gdynia", "Sopot", "Tczew", "Starogard Gdański", "Wejherowo", "Kościerzyna"],
    "West Pomeranian Voivodeship": ["Szczecin", "Koszalin", "Świnoujście", "Stargard", "Police", "Gryfino", "Kołobrzeg"],
    "Lublin Voivodeship": ["Lublin", "Chełm", "Zamość", "Biała Podlaska", "Puławy", "Kraśnik"],
    "Podlaskie Voivodeship": ["Białystok", "Suwałki", "Łomża", "Augustów", "Sokółka", "Hajnówka"],
    "Świętokrzyskie Voivodeship": ["Kielce", "Ostrowiec Świętokrzyski", "Starachowice", "Skarżysko-Kamienna", "Sandomierz"],
    "Warmian-Masurian Voivodeship": ["Olsztyn", "Elbląg", "Ełk", "Iława", "Mrągowo", "Giżycko"],
    "Lubusz Voivodeship": ["Gorzów Wielkopolski", "Zielona Góra", "Nowa Sól", "Żary", "Żagań", "Międzyrzecz"],
    "Kuyavian-Pomeranian Voivodeship": ["Bydgoszcz", "Toruń", "Włocławek", "Grudziädz", "Inowrocław", "Brodnica"],
    "Opole Voivodeship": ["Opole", "Kędzierzyn-Koźle", "Nysa", "Brzeg", "Prudnik", "Strzelce Opolskie"],
    "Subcarpathian Voivodeship": ["Rzeszów", "Przemyśl", "Stalowa Wola", "Mielec", "Tarnobrzeg", "Krosno", "Jarosław"]
  },
  "Ireland": {
    "County Dublin": ["Dublin City", "Tallaght", "Dún Laoghaire", "Swords", "Blanchardstown", "Lucan", "Malahide"],
    "County Cork": ["Cork City", "Ballincollig", "Carrigaline", "Midleton", "Cobh", "Mallow", "Youghal"],
    "County Galway": ["Galway City", "Tuam", "Ballinasloe", "Loughrea", "Oranmore", "Athenry", "Clifden"],
    "County Limerick": ["Limerick City", "Newcastle West", "Abbeyfeale", "Rathkeale", "Kilmallock", "Adare"],
    "County Waterford": ["Waterford City", "Dungarvan", "Tramore", "Dunmore East", "Lismore", "Portlaw"],
    "County Kerry": ["Tralee", "Killarney", "Listowel", "Kenmare", "Dingle", "Cahersiveen"],
    "County Clare": ["Ennis", "Shannon", "Kilrush", "Ennistymon", "Kilkee", "Newmarket-on-Fergus"],
    "County Wexford": ["Wexford Town", "Enniscorthy", "Gorey", "New Ross", "Rosslare", "Bunclody"],
    "County Mayo": ["Castlebar", "Ballina", "Westport", "Claremorris", "Swinford", "Belmullet"],
    "County Donegal": ["Letterkenny", "Buncrana", "Ballybofey", "Donegal Town", "Carndonagh", "Bundoran"],
    "County Kildare": ["Naas", "Newbridge", "Maynooth", "Celbridge", "Leixlip", "Athy", "Kildare Town"],
    "County Meath": ["Navan", "Drogheda (part)", "Trim", "Ashbourne", "Kells", "Dunboyne", "Duleek"],
    "County Wicklow": ["Bray", "Greystones", "Arklow", "Wicklow Town", "Rathdrum", "Blessington"],
    "County Louth": ["Dundalk", "Drogheda (part)", "Ardee", "Carlingford", "Dunleer"],
    "County Tipperary": ["Clonmel", "Nenagh", "Thurles", "Tipperary Town", "Carrick-on-Suir", "Roscrea", "Cahir"],
    "County Kilkenny": ["Kilkenny City", "Callan", "Thomastown", "Graiguenamanagh", "Castlecomer"]
  },
  "Canada": {
    "Ontario": ["Toronto", "Ottawa", "Mississauga", "Brampton", "Hamilton", "London", "Markham", "Vaughan", "Kitchener", "Windsor"],
    "Quebec": ["Montreal", "Quebec City", "Laval", "Gatineau", "Longueuil", "Sherbrooke", "Saguenay", "Trois-Rivières"],
    "British Columbia": ["Vancouver", "Surrey", "Burnaby", "Richmond", "Kelowna", "Coquitlam", "Langley", "Delta", "Victoria"],
    "Alberta": ["Calgary", "Edmonton", "Red Deer", "Lethbridge", "St. Albert", "Medicine Hat", "Grande Prairie", "Airdrie"],
    "Manitoba": ["Winnipeg", "Brandon", "Thompson", "Steinbach", "Portage la Prairie", "Winkler", "Selkirk"],
    "Saskatchewan": ["Saskatoon", "Regina", "Prince Albert", "Moose Jaw", "Yorkton", "Swift Current", "North Battleford"],
    "Nova Scotia": ["Halifax", "Sydney", "Dartmouth", "Truro", "New Glasgow", "Glace Bay", "Amherst"],
    "New Brunswick": ["Moncton", "Saint John", "Fredericton", "Dieppe", "Miramichi", "Edmundston", "Bathurst"],
    "Newfoundland and Labrador": ["St. John's", "Mount Pearl", "Corner Brook", "Grand Falls-Windsor", "Gander", "Labrador City"],
    "Prince Edward Island": ["Charlottetown", "Summerside", "Stratford", "Montague", "Kensington", "Alberton"],
    "Northwest Territories": ["Yellowknife", "Hay River", "Inuvik", "Fort Smith", "Behchokǫ"],
    "Yukon": ["Whitehorse", "Dawson City", "Watson Lake", "Haines Junction", "Carmacks"],
    "Nunavut": ["Iqaluit", "Rankin Inlet", "Arviat", "Baker Lake", "Cambridge Bay", "Pangnirtung"]
  },
  "Italy": {
    "Lombardy": ["Milan", "Bergamo", "Brescia", "Monza", "Como", "Varese", "Lecco", "Cremona", "Mantua"],
    "Lazio": ["Rome", "Latina", "Frosinone", "Viterbo", "Rieti", "Guidonia Montecelio", "Civitavecchia"],
    "Campania": ["Naples", "Salerno", "Caserta", "Benevento", "Avellino", "Pompei", "Sorrento", "Capri"],
    "Sicily": ["Palermo", "Catania", "Messina", "Syracuse", "Trapani", "Agrigento", "Ragusa", "Caltanissetta"],
    "Veneto": ["Venice", "Verona", "Padua", "Vicenza", "Treviso", "Belluno", "Rovigo", "Chioggia"],
    "Piedmont": ["Turin", "Novara", "Alessandria", "Asti", "Cuneo", "Vercelli", "Biella", "Verbania"],
    "Emilia-Romagna": ["Bologna", "Parma", "Modena", "Reggio Emilia", "Ravenna", "Ferrara", "Forlì", "Rimini", "Piacenza"],
    "Tuscany": ["Florence", "Pisa", "Lucca", "Arezzo", "Siena", "Prato", "Livorno", "Grosseto", "Massa"],
    "Apulia": ["Bari", "Lecce", "Taranto", "Foggia", "Brindisi", "Barletta", "Trani", "Andria"],
    "Liguria": ["Genoa", "La Spezia", "Savona", "Sanremo", "Imperia", "Rapallo", "Portofino"],
    "Marche": ["Ancona", "Pesaro", "Urbino", "Macerata", "Ascoli Piceno", "Fermo", "Senigallia"],
    "Abruzzo": ["L'Aquila", "Pescara", "Chieti", "Teramo", "Avezzano", "Vasto", "Sulmona"],
    "Umbria": ["Perugia", "Assisi", "Terni", "Foligno", "Spoleto", "Città di Castello", "Gubbio"],
    "Calabria": ["Reggio Calabria", "Catanzaro", "Cosenza", "Crotone", "Vibo Valentia", "Lamezia Terme"],
    "Sardinia": ["Cagliari", "Sassari", "Olbia", "Nuoro", "Oristano", "Alghero", "Carbonia"],
    "Friuli-Venezia Giulia": ["Trieste", "Udine", "Pordenone", "Gorizia", "Monfalcone", "Cervignano del Friuli"],
    "Trentino-Alto Adige": ["Trento", "Bolzano", "Merano", "Brixen", "Rovereto", "Pergine Valsugana"],
    "Molise": ["Campobasso", "Isernia", "Termoli", "Venafro", "Bojano", "Larino"],
    "Basilicata": ["Potenza", "Matera", "Melfi", "Pisticci", "Lauria", "Bernalda"],
    "Aosta Valley": ["Aosta", "Courmayeur", "Cervinia", "La Thuile", "Saint-Vincent", "Pré-Saint-Didier"]
  },
  "Romania": {
    "Alba": ["Alba Iulia", "Sebeș", "Blaj", "Aiud", "Cugir"],
    "Arad": ["Arad", "Ineu", "Chişineu-Criş", "Lipova", "Pâncota"],
    "Argeş": ["Piteşti", "Curtea de Argeş", "Câmpulung", "Mioveni", "Costeşti"],
    "Bacău": ["Bacău", "Oneşti", "Moineşti", "Comăneşti", "Buhuşi"],
    "Bihor": ["Oradea", "Salonta", "Beiuş", "Marghita", "Aleşd"],
    "Bistriţa-Năsăud": ["Bistriţa", "Beclean", "Năsăud", "Sângeorz-Băi"],
    "Botoşani": ["Botoşani", "Dorohoi", "Darabani", "Săveni", "Flămânzi"],
    "Brăila": ["Brăila", "Ianca", "Însurăţei", "Făurei"],
    "Braşov": ["Braşov", "Făgăraş", "Săcele", "Codlea", "Zărneşti"],
    "Bucureşti (Capital)": ["Bucharest", "Sector 1", "Sector 2", "Sector 3", "Sector 4", "Sector 5", "Sector 6"],
    "Buzău": ["Buzău", "Râmnicu Sărat", "Nehoiu", "Pogoanele"],
    "Călăraşi": ["Călăraşi", "Olteniţa", "Lehliu Gară", "Budeşti"],
    "Caraş-Severin": ["Reşiţa", "Caransebeş", "Bocşa", "Oraviţa", "Moldova Nouă"],
    "Cluj": ["Cluj-Napoca", "Turda", "Dej", "Câmpia Turzii", "Gherla"],
    "Constanţa": ["Constanţa", "Mangalia", "Medgidia", "Năvodari", "Cernavodă"],
    "Covasna": ["Sfântu Gheorghe", "Târgu Secuiesc", "Covasna", "Întorsura Buzăului"],
    "Dâmboviţa": ["Târgovişte", "Moreni", "Pucioasa", "Găeşti", "Titu"],
    "Dolj": ["Craiova", "Băileşti", "Calafat", "Filiaşi", "Segarcea"],
    "Galaţi": ["Galaţi", "Tecuci", "Târgu Bujor", "Bereşti"],
    "Giurgiu": ["Giurgiu", "Bolintin-Vale", "Mihăileşti"],
    "Gorj": ["Târgu Jiu", "Motru", "Rovinari", "Novaci", "Bumbeşti-Jiu"],
    "Harghita": ["Miercurea Ciuc", "Odorheiu Secuiesc", "Gheorgheni", "Topliţa"],
    "Hunedoara": ["Deva", "Hunedoara", "Petroşani", "Lupeni", "Vulcan"],
    "Ialomiţa": ["Slobozia", "Feteşti", "Urziceni", "Ţăndărei"],
    "Iaşi": ["Iaşi", "Paşcani", "Hârlău", "Târgu Frumos"],
    "Ilfov": ["Buftea", "Voluntari", "Pantelimon", "Popeşti-Leordeni", "Bragadiru"],
    "Maramureş": ["Baia Mare", "Sighetu Marmaţiei", "Borşa", "Vişeu de Sus"],
    "Mehedinţi": ["Drobeta-Turnu Severin", "Orşova", "Vânju Mare", "Strehaia"],
    "Mureş": ["Târgu Mureş", "Reghin", "Sighişoara", "Târnăveni", "Luduş"],
    "Neamţ": ["Piatra Neamţ", "Roman", "Târgu Neamţ", "Bicaz"],
    "Olt": ["Slatina", "Caracal", "Balş", "Corabia", "Scorniceşti"],
    "Prahova": ["Ploieşti", "Câmpina", "Sinaia", "Buşteni", "Azuga"],
    "Sălaj": ["Zalău", "Şimleu Silvaniei", "Jibou", "Cehu Silvaniei"],
    "Satu Mare": ["Satu Mare", "Carei", "Negreşti-Oaş", "Tăşnad"],
    "Sibiu": ["Sibiu", "Mediaş", "Cisnădie", "Agnita", "Avrig"],
    "Suceava": ["Suceava", "Botoşani", "Fălticeni", "Rădăuţi", "Câmpulung Moldovenesc"],
    "Teleorman": ["Alexandria", "Rosiori de Vede", "Turnu Măgurele", "Zimnicea"],
    "Timiş": ["Timişoara", "Lugoj", "Sânnicolau Mare", "Jimbolia"],
    "Tulcea": ["Tulcea", "Babadag", "Măcin", "Sulina"],
    "Vaslui": ["Vaslui", "Bârlad", "Huşi", "Negreşti"],
    "Vâlcea": ["Râmnicu Vâlcea", "Drăgăşani", "Băile Olăneşti", "Călimăneşti"],
    "Vrancea": ["Focşani", "Adjud", "Mărăşeşti", "Panciu"]
  },
  "Hungary": {
    "Bács-Kiskun": ["Kecskemét", "Baja", "Kalocsa", "Kiskunfélegyháza", "Kiskunhalas"],
    "Baranya": ["Pécs", "Komló", "Mohács", "Szigetvár", "Siklós"],
    "Békés": ["Békéscsaba", "Gyula", "Orosháza", "Szarvas", "Békés"],
    "Borsod-Abaúj-Zemplén": ["Miskolc", "Ózd", "Kazincbarcika", "Sátoraljaújhely", "Tiszaújváros"],
    "Csongrád-Csanád": ["Szeged", "Hódmezővásárhely", "Makó", "Szentes", "Mórahalom"],
    "Fejér": ["Székesfehérvár", "Dunaújváros", "Mór", "Bicske", "Gárdony"],
    "Győr-Moson-Sopron": ["Győr", "Sopron", "Mosonmagyaróvár", "Csorna", "Kapuvár"],
    "Hajdú-Bihar": ["Debrecen", "Hajdúböszörmény", "Hajdúszoboszló", "Berettyóújfalu", "Balmazújváros"],
    "Heves": ["Eger", "Hatvan", "Gyöngyös", "Füzesabony", "Heves"],
    "Jász-Nagykun-Szolnok": ["Szolnok", "Jászberény", "Karcag", "Törökszentmiklós", "Mezőtúr"],
    "Komárom-Esztergom": ["Tatabánya", "Esztergom", "Komárom", "Oroszlány", "Tata"],
    "Nógrád": ["Salgótarján", "Balassagyarmat", "Pásztó", "Bátonyterenye", "Rétság"],
    "Pest": ["Érd", "Gödöllő", "Vác", "Cegléd", "Dunakeszi"],
    "Somogy": ["Kaposvár", "Siófok", "Marcali", "Barcs", "Fonyód"],
    "Szabolcs-Szatmár-Bereg": ["Nyíregyháza", "Kisvárda", "Mátészalka", "Nyírbátor", "Fehérgyarmat"],
    "Tolna": ["Szekszárd", "Dombóvár", "Paks", "Tamási", "Bonyhád"],
    "Vas": ["Szombathely", "Sárvár", "Körmend", "Szentgotthárd", "Celldömölk"],
    "Veszprém": ["Veszprém", "Ajka", "Várpalota", "Pápa", "Balatonfüred"],
    "Zala": ["Zalaegerszeg", "Nagykanizsa", "Keszthely", "Lenti", "Zalaszentgrót"],
    "Budapest (Capital)": ["Budapest", "District I", "District II", "District III", "District IV", "District V"]
  },
  "Lithuania": {
    "Alytus County": ["Alytus", "Varėna", "Druskininkai", "Lazdijai"],
    "Kaunas County": ["Kaunas", "Jonava", "Kėdainiai", "Kaišiadorys", "Prienai"],
    "Klaipėda County": ["Klaipėda", "Mažeikiai", "Plungė", "Kretinga", "Palanga"],
    "Marijampolė County": ["Marijampolė", "Vilkaviškis", "Šakiai", "Kazlų Rūda"],
    "Panevėžys County": ["Panevėžys", "Kupiškis", "Rokiškis", "Biržai", "Pasvalys"],
    "Šiauliai County": ["Šiauliai", "Radviliškis", "Kelmė", "Pakruojis", "Joniškis"],
    "Tauragė County": ["Tauragė", "Šilutė", "Jurbarkas", "Pagėgiai"],
    "Telšiai County": ["Telšiai", "Mažeikiai", "Plungė", "Rietavas"],
    "Utena County": ["Utena", "Visaginas", "Anykščiai", "Molėtai", "Zarasai"],
    "Vilnius County": ["Vilnius (Capital)", "Ukmergė", "Elektrėnai", "Šalčininkai", "Trakai"]
  },
  "Czech Republic": {
    "Prague": ["Prague"],
    "Central Bohemian": ["Prague", "Brno", "Ostrava"],
    "South Bohemian": ["České Budějovice"],
    "Plzeň": ["Plzeň"],
    "Karlovy Vary": ["Karlovy Vary"],
    "Ústí nad Labem": ["Ústí nad Labem"],
    "Liberec": ["Liberec"],
    "Hradec Králové": ["Hradec Králové"],
    "Pardubice": ["Pardubice"],
    "Vysočina": ["Jihlava"],
    "South Moravian": ["Brno"],
    "Olomouc": ["Olomouc"],
    "Zlín": ["Zlín"],
    "Moravian-Silesian": ["Ostrava"]
  },
  "Slovakia": {
    "Bratislava": ["Bratislava"],
    "Trnava": ["Trnava"],
    "Trenčín": ["Trenčín"],
    "Nitra": ["Nitra"],
    "Žilina": ["Žilina", "Martin"],
    "Banská Bystrica": ["Banská Bystrica"],
    "Prešov": ["Prešov", "Poprad"],
    "Košice": ["Košice"]
  },
  "Belgium": {
    "Antwerp": ["Antwerp"],
    "East Flanders": ["Ghent"],
    "West Flanders": ["Bruges"],
    "Limburg": ["Hasselt"],
    "Flemish Brabant": ["Leuven"],
    "Walloon Brabant": ["Brussels"],
    "Hainaut": ["Charleroi", "Mons"],
    "Liège": ["Liège"],
    "Luxembourg": ["Namur"],
    "Namur": ["Namur"],
    "Brussels-Capital Region": ["Brussels"]
  },
  "Spain": {
    "Andalusia": ["Seville", "Málaga", "Córdoba"],
    "Aragon": ["Zaragoza"],
    "Asturias": ["Asturias"],
    "Balearic Islands": ["Palma"],
    "Basque Country": ["Bilbao"],
    "Canary Islands": ["Canary Islands"],
    "Cantabria": ["Cantabria"],
    "Castile and León": ["Valladolid"],
    "Castile-La Mancha": ["Castile-La Mancha"],
    "Catalonia": ["Barcelona"],
    "Extremadura": ["Extremadura"],
    "Galicia": ["Galicia"],
    "La Rioja": ["La Rioja"],
    "Community of Madrid": ["Madrid"],
    "Region of Murcia": ["Murcia"],
    "Navarre": ["Navarre"],
    "Valencian Community": ["Valencia", "Alicante"]
  },
  "Macau": {
    "Macau SAR": ["Macau Peninsula", "Taipa", "Coloane", "Cotai"]
  },
  "Philippines": {
    "Metro Manila (NCR)": ["Manila", "Quezon City", "Makati", "Taguig", "Pasay", "Pasig"],
    "Cebu": ["Cebu City"],
    "Davao del Sur": ["Davao City"],
    "Pampanga": ["Angeles City"],
    "Iloilo": ["Bacolod"]
  },
  "Indonesia": {
    "Jakarta (DKI Jakarta)": ["Jakarta"],
    "West Java": ["Bandung", "Bekasi"],
    "Central Java": ["Semarang", "Yogyakarta"],
    "East Java": ["Surabaya"],
    "Banten": ["Tangerang"],
    "Bali": ["Denpasar"],
    "North Sumatra": ["Medan"],
    "South Sulawesi": ["Makassar"]
  },
  "Sri Lanka": {
    "Western Province": ["Colombo", "Negombo"],
    "Central Province": ["Kandy"],
    "Southern Province": ["Galle", "Matara"],
    "Northern Province": ["Jaffna"],
    "North Western Province": ["Kurunegala"],
    "North Central Province": ["Anuradhapura"],
    "Eastern Province": ["Batticaloa"],
    "Sabaragamuwa Province": ["Ratnapura"]
  },
  "India": {
    "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool", "Anantapur"],
    "Arunachal Pradesh": ["Itanagar"],
    "Assam": ["Guwahati", "Dibrugarh", "Silchar", "Jorhat"],
    "Bihar": ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia"],
    "Chhattisgarh": ["Raipur", "Bhilai", "Bilaspur", "Korba", "Durg"],
    "Goa": ["Panaji", "Margao", "Vasco da Gama"],
    "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Anand", "Gandhinagar"],
    "Haryana": ["Gurugram", "Faridabad", "Panipat", "Ambala", "Hisar", "Rohtak"],
    "Himachal Pradesh": ["Shimla", "Dharamshala", "Solan"],
    "Jharkhand": ["Ranchi", "Dhanbad", "Jamshedpur", "Bokaro", "Deoghar"],
    "Karnataka": ["Bengaluru", "Mysuru", "Mangaluru", "Hubballi", "Belagavi", "Davanagere", "Ballari"],
    "Kerala": ["Kochi", "Thiruvananthapuram", "Kozhikode", "Thrissur", "Kollam", "Alappuzha"],
    "Madhya Pradesh": ["Indore", "Bhopal", "Gwalior", "Jabalpur", "Ujjain", "Sagar"],
    "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad", "Thane", "Kolhapur", "Solapur", "Amravati", "Sangli"],
    "Manipur": ["Imphal"],
    "Meghalaya": ["Shillong"],
    "Mizoram": ["Aizawl"],
    "Nagaland": ["Kohima", "Dimapur"],
    "Odisha": ["Bhubaneswar", "Cuttack", "Rourkela", "Sambalpur", "Berhampur"],
    "Punjab": ["Amritsar", "Ludhiana", "Jalandhar", "Patiala", "Bathinda", "Mohali"],
    "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Ajmer", "Kota", "Bikaner", "Alwar", "Bhilwara"],
    "Sikkim": ["Gangtok"],
    "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Salem", "Tiruchirappalli", "Tirunelveli", "Erode", "Vellore"],
    "Telangana": ["Hyderabad", "Warangal", "Nizamabad", "Khammam", "Karimnagar"],
    "Tripura": ["Agartala"],
    "Uttar Pradesh": ["Lucknow", "Kanpur", "Noida", "Ghaziabad", "Meerut", "Agra", "Varanasi", "Prayagraj", "Aligarh", "Bareilly", "Moradabad", "Gorakhpur", "Jhansi"],
    "Uttarakhand": ["Dehradun", "Haridwar", "Roorkee", "Haldwani"],
    "West Bengal": ["Kolkata", "Siliguri", "Durgapur", "Asansol", "Howrah", "Kharagpur", "Bardhaman"],
    "Delhi": ["New Delhi", "North Delhi", "South Delhi", "West Delhi", "East Delhi"]
  },
  "Nepal": {
    "Bagmati Province": ["Kathmandu", "Lalitpur", "Bharatpur"],
    "Gandaki Province": ["Pokhara"],
    "Koshi Province": ["Biratnagar"],
    "Madhesh Province": ["Birgunj"],
    "Lumbini Province": ["Nepalgunj"],
    "Sudurpashchim Province": ["Dhangadhi"]
  },
  "Bangladesh": {
    "Dhaka": ["Dhaka", "Gazipur", "Narayanganj"],
    "Chattogram": ["Chattogram", "Cumilla"],
    "Rajshahi": ["Rajshahi"],
    "Khulna": ["Khulna"],
    "Barishal": ["Barishal"],
    "Sylhet": ["Sylhet"],
    "Rangpur": ["Rangpur"]
  },
  "Pakistan": {
    "Punjab": ["Lahore", "Faisalabad", "Multan", "Rawalpindi", "Sialkot"],
    "Sindh": ["Karachi", "Hyderabad"],
    "Khyber Pakhtunkhwa (KPK)": ["Peshawar"],
    "Balochistan": ["Quetta"],
    "Islamabad Capital Territory (ICT)": ["Islamabad"]
  },
  "Ethiopia": {
    "Addis Ababa": ["Addis Ababa"],
    "Oromia": ["Adama", "Jimma", "Bishoftu"],
    "Amhara": ["Bahir Dar", "Gondar", "Dessie"],
    "Tigray": ["Mekelle"],
    "SNNPR": ["Hawassa"],
    "Dire Dawa": ["Dire Dawa"]
  }
};
